
const state = {
  isVisibleModal: false,
  isVisibleModalRegister: false,
  isVisibleModalExport: false
}

const mutations = {
  'TOGGLE_VISIBILITY_MODAL' (state, payload = false) {
    state.isVisibleModal = !!payload
  },
  'TOGGLE_VISIBILITY_MODAL_REGISTER' (state, payload = false) {
    state.isVisibleModalRegister = !!payload
  },
  'TOGGLE_VISIBILITY_MODAL_EXPORT' (state, payload = false) {
    state.isVisibleModalExport = !!payload
  }
}

const actions = {
  showModal ({ commit }) {
    commit('TOGGLE_VISIBILITY_MODAL', true)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
